import { PATH_API_BASE } from '../config'
import { createWatchRequests } from '@fe/redux/sagas/network'

export * from '@fe/redux/sagas/network'

export const watchRequests = createWatchRequests(PATH_API_BASE)
